import api from '@/services/api'
import axios from 'axios'

/**
 * Sube un archivo a S3 usando una URL prefirmada obtenida del backend.
 *
 * @param {Object} options
 * @param {File} options.file - El archivo (File object del input)
 * @param {string} options.carpeta - Carpeta S3: 'productos', 'extras', 'vehiculos', 'avatars', 'servicios', 'reservas'
 * @returns {Promise<{ key: string }>} La key S3 del archivo subido (ej. "productos/abc123.jpg")
 */
export async function uploadFileToS3({ file, carpeta }) {
  const contentType = file.type || 'application/octet-stream'

  // Paso 1: Obtener URL prefirmada del backend
  const { data } = await api.post('/s3/presigned-url', { carpeta, contentType })
  const { uploadUrl, key } = data

  // Paso 2: Subir archivo directo a S3 (axios puro, sin interceptor de api.js)
  await axios.put(uploadUrl, file, {
    headers: { 'Content-Type': contentType },
  })

  return { key }
}

/**
 * Resuelve la URL completa de una imagen a partir de su key S3.
 *
 * @param {string} key - Key S3 (ej. "productos/abc.jpg") o URL completa
 * @returns {string} URL completa de la imagen
 */
export function resolveImageUrl(key) {
  if (!key) return key

  // Si ya es una URL completa, devolver tal cual
  if (key.startsWith('http://') || key.startsWith('https://')) {
    return key
  }

  // Construir URL del bucket S3
  const bucketUrl = process.env.VUE_APP_S3_BUCKET_URL.replace(/\/+$/, '')
  return `${bucketUrl}/${key.replace(/^\/+/, '')}`
}
